// extracted by mini-css-extract-plugin
export default {"document":"CarouselNode_document__pJ+42","text":"CarouselNode_text__CgygP","placeholder":"CarouselNode_placeholder__H-Qxu","cards-container":"CarouselNode_cards-container__i-qag"};